<abi-spinner *ngIf="loading" [indeterminate]="submitting" [value]="uploadProgress"></abi-spinner>

<abi-upload-splash *ngIf="uploadingFiles"></abi-upload-splash>

<div class="mt-2">
<form role="form" [formGroup]="form" autocomplete="off">
    <!-- Confirmation Page Buttons -->
    <div *ngIf="confirmPage && !loading" class="btn-group float-right">
        <button
            type="button"
            class="btn btn-outline-primary"
            (click)="previousPage()"
        >
            <i class="fas fa-chevron-left"></i>
            {{ "System.Previous" | translate }}
        </button>
        <button
            type="button"
            class="btn btn-outline-primary"
            (click)="finish()"
        >
            <i class="fas fa-check"></i> {{ "System.Finish" | translate }}
        </button>
    </div>

    <!-- PRIMARY Navigation -->
    <abi-nav-dropdown [hidden]="confirmPage">
        <div class="btn-group mr-1">
            <button
                *ngIf="firstPage"
                type="button"
                class="btn btn-outline-primary"
                (click)="cancel()"
                [attr.caption]="'System.Cancel' | translate"
            >
                <i class="fas fa-times"></i>
            </button>
        </div>
        <button
            *ngIf="confirmPage"
            type="button"
            class="btn btn-outline-primary"
            (click)="previousPage()"
        >
            <i class="fas fa-chevron-left"></i>
            {{ "System.Previous" | translate }}
        </button>
        <div after class="btn-group ml-1">
            <button
                *ngIf="lastPage"
                type="button"
                class="btn btn-outline-primary"
                (click)="finish()"
            >
                <i class="fas fa-check"></i> {{ 'System.Finish' | translate }}
            </button>
        </div>

        <ul
            ngbNav
            #nav="ngbNav"
            class="nav-pills"
            [activeId]="activePage"
            [destroyOnHide]="false"
            (navChange)="beforeChange($event)"
            (activeIdChange)="afterChange($event)"
        >
            <!-- SOURCE TAB -->

            <li ngbNavItem="source" *ngIf="registrationTabs.includes('sources')">
                <a ngbNavLink
                    >
                    <abi-group-status
                        [group]="form.controls.sourceId"
                        [name]="'source'"
                    ></abi-group-status
                >{{ "Job.Source" | translate }}</a>
                <ng-template ngbNavContent>
                    <mat-divider class="mb-3"></mat-divider>
                    <div class="row">
                        <abi-form-field
                            label="JobNew.Source"
                            [errors]="formErrors.sourceId"
                        >
                            <abi-job-source-select
                                formControlName="sourceId"
                            ></abi-job-source-select>
                        </abi-form-field>
                    </div>
                </ng-template>
            </li>

            <li ngbNavItem="contact" *ngIf="registrationTabs.includes('contact')">
                <a ngbNavLink
                    >
                    <abi-group-status
                        [group]="form.controls.contact"
                    ></abi-group-status
                >{{ "Job.Contact" | translate }}</a>
                <ng-template ngbNavContent>
                    <mat-divider class="mb-3"></mat-divider>
                    <abi-contact formControlName="contact" [type]="customerContactType" context="Registration"></abi-contact>
                    <mat-divider class="mb-3 mt-2"></mat-divider>
                    <p translate="CustomerNew.ContactNote"></p>
                </ng-template>
            </li>

            <!-- ADDRESS TAB -->
            <li ngbNavItem="address" *ngIf="registrationTabs.includes('address')">
                <a ngbNavLink
                    >
                    <abi-group-status
                        [group]="form.controls.address"
                        name="address"
                    ></abi-group-status
                >{{ "Job.Address" | translate }}</a>
                <ng-template ngbNavContent>


                    <mat-divider class="mb-3"></mat-divider>
                    <!-- non-sensible model/group properties - todo: migrate to 'formControl' only -->
                    <abi-address formControlName="address"></abi-address>
                    <mat-divider class="mb-3"></mat-divider>
                    <p translate="CustomerNew.AddressNote"></p>
                </ng-template>
            </li>

            <li ngbNavItem="machine" *ngIf="registrationTabs.includes('machine')">
                <a ngbNavLink
                    >
                    <abi-group-status
                        [group]="form.controls.machineMaster"
                    ></abi-group-status
                >{{ "Job.Machine" | translate }}</a>
                <ng-template ngbNavContent>
                    <mat-divider class="mb-3"></mat-divider>
                    <abi-machine-master
                        [group]="form.controls.machineMaster"
                        [formErrors]="formErrors"
                        context="Registration"
                        [filterModelsBy]="filterModelsBy"
                        class="d-block mb-3"
                    >
                    </abi-machine-master>

                    <mat-divider class="mb-3 mt-1"></mat-divider>
                    <p translate="CustomerNew.MachineNote"></p>
                </ng-template>
            </li>

            <!-- DEALER TAB -->
            <li ngbNavItem="dealerContact" *ngIf="dealerTabVisible">
                <a ngbNavLink
                    >
                    <abi-group-status
                        [group]="form.controls.dealerContact"
                        name="DealerContact"
                    ></abi-group-status
                >{{ "Job.Dealer" | translate }}</a>
                <ng-template ngbNavContent>
                    <mat-divider class="mb-3"></mat-divider>
                    <!-- implement 'validateDealer' -->
                    <abi-contact
                        formControlName="dealerContact"
                        [validates]="dealerValidate"
                        type="Dealer"
                    ></abi-contact>
                    <mat-divider class="mb-3 mt-2"></mat-divider>
                    <p translate="CustomerNew.DealerNote"></p>
                </ng-template>
            </li>
            <!-- <li ngbNavItem>
                <button
                ngbNavLink
                *ngIf="firstPage"
                type="button"
                class="btn btn-outline-primary"
                (click)="cancel()"
            >
                <i class="fas fa-times"></i>
                {{ "System.Cancel" | translate }}
            </button>
            <button
            ngbNavLink
                *ngIf="!firstPage"
                type="button"
                class="btn btn-outline-primary"
                (click)="previousPage()"
            >
                <i class="fas fa-chevron-left"></i>
                {{ "System.Previous" | translate }}
            </button>
            <button
            ngbNavLink
                *ngIf="!lastPage"
                type="button"
                class="btn btn-outline-primary"
                (click)="nextPage()"
            >
                <i class="fas fa-chevron-right"></i>
                {{ "System.Next" | translate }}
            </button>
            <button
            ngbNavLink
                *ngIf="lastPage"
                type="button"
                class="btn btn-outline-primary"
                (click)="finish()"
            >
                <i class="fas fa-check"></i>
                {{ "System.Finish" | translate }}
            </button>
            </li> -->
        </ul>
    </abi-nav-dropdown>

    <div [hidden]="confirmPage" class="position-relative">
        <div #navContent [ngbNavOutlet]="nav" class="mt-3"></div>
        <div class="d-none d-md-block nav-buttons">
            <div class="d-flex justify-content-end">
                <div class="btn-group pt-0">
                    <button
                        *ngIf="firstPage"
                        type="button"
                        class="btn btn-outline-primary"
                        (click)="cancel()"
                    >
                        <i class="fas fa-times"></i>
                        {{ "System.Cancel" | translate }}
                    </button>
                    <button
                        *ngIf="!firstPage"
                        type="button"
                        class="btn btn-outline-primary"
                        (click)="previousPage()"
                    >
                        <i class="fas fa-chevron-left"></i>
                        {{ "System.Previous" | translate }}
                    </button>
                    <button
                        *ngIf="!lastPage"
                        type="button"
                        class="btn btn-outline-primary"
                        (click)="nextPage()"
                    >{{ "System.Next" | translate }} <i class="fas fa-chevron-right"></i>
                    </button>
                    <button
                        *ngIf="lastPage"
                        type="button"
                        class="btn btn-outline-primary"
                        (click)="finish()"
                    >
                        <i class="fas fa-check"></i>
                        {{ "System.Finish" | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <abi-customer-confirm
        *ngIf="confirmPage && !loading"
        [customer]="confirmCustomer"
        [files]="machineAttachments"
        [job]="createRegistrationJob ? job : null"
    ></abi-customer-confirm>
</form>
</div>

<ng-template #submitted>
    <h4 mat-dialog-title>{{ "CustomerNew.CustomerNew" | translate }}</h4>
    <mat-dialog-content>
        <p translate="CustomerNew.SubmitMessage"></p>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button type="button" mat-button mat-dialog-close="true" cdkFocusInitial>
            {{ "CustomerNew.Ok" | translate }}
        </button>
    </mat-dialog-actions>
</ng-template>

<ng-container *ngIf="isDebug">
    <pre>{{ form.getRawValue() | json }}</pre>
</ng-container>
